export function OutlineEyeSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.17109 9.16797C8.44681 9.89277 8.00073 10.8912 8.00073 12C8.00073 14.208 9.78984 15.9984 12.001 15.9984C13.1042 15.9984 14.1019 15.552 14.8262 14.8272"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1616 8.16602C14.4327 8.55482 15.4352 9.55802 15.8237 10.83"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.36279 4.36374C10.207 4.12374 11.0943 3.99414 12.0009 3.99414C15.9244 3.99414 19.4883 6.37014 20.9992 9.99894"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.0388 6.0332C4.72455 7.046 3.65972 8.3996 2.9978 9.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9998 14.002C20.8078 14.4676 20.5774 14.9092 20.323 15.3316"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.9978 14.002C4.50871 17.626 8.07253 20.002 12.0009 20.002C14.1977 20.002 16.2794 19.258 17.9582 17.962"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.29079 9.28711C9.10852 9.46951 8.99341 9.71911 8.99341 9.99751C8.99341 10.5495 9.44428 10.9959 9.99588 10.9959C10.2741 10.9959 10.5235 10.8855 10.701 10.7031"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.00732 3L20.9943 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
